import React from 'react';
import { DATE_FORMAT } from '@atlassian/cssxp-typescommon';
import { Refund } from '@atlassian/cssxp-types-billing';
import { FormattedDate } from '@css-xp/base';
import { InfoSection, SoldToCompanyName, FormatCurrency } from '@css-xp/ppc-common';
import { RefundPaidDate } from '../refund-paid-date';

export const RefundInfoSection = ({ refund, txaId }: { refund: Refund; txaId?: string }) => {
  // Logic same as:
  // 1. packages/components/partner-purchase-center/pages/invoices/src/components/refund-details-summary-section/refund-details-summary-section.tsx

  return (
    <>
      <InfoSection
        items={[
          {
            label: 'Issued',
            value: <FormattedDate date={refund.createdDate} />,
          },
          {
            label: 'Paid',
            value: <RefundPaidDate refund={refund} label="" hideTime={true} dateFormat={DATE_FORMAT} />,
          },
          {
            label: 'Customer',
            value: (
              <SoldToCompanyName txaId={txaId} companyName={refund?.shipTo?.fullName} shouldRemoveLineClamp={true} />
            ),
          },
          {
            label: 'Total amount',
            value: (
              <p className="total-amount-value">
                <FormatCurrency
                  showCurrencyCode
                  showCommas
                  currency={refund?.currency}
                  value={refund.total as string}
                />
              </p>
            ),
            isRightAligned: true,
          },
        ]}
      />
      <br />
    </>
  );
};
